import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./i18n";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Remove loading skeleton after React hydrates
if (typeof window !== 'undefined') {
  const loader = document.getElementById('vx-loader');
  if (loader) loader.remove();
}
